import React, { useState } from "react";

// Example address list
const addresses = [
  { id: 1, street: "123 Main St", lat: 25.276987, lng: 55.296249, city: "Dubai" },
  { id: 2, street: "No Location", lat: null, lng: null },
  // Add more addresses as needed
];

function AddressList() {
  const [selected, setSelected] = useState(null);

  return (
    <div>
      {addresses.map(addr => (
        <div key={addr.id} className="mb-2">
          <span>{addr.street}</span>
          {addr.lat && addr.lng && (
            <button
              className="ml-2 px-2 py-1 bg-blue-500 text-white rounded"
              onClick={() => setSelected(addr)}
            >
              View on Map
            </button>
          )}
        </div>
      ))}
      {selected && (
        <div className="mt-4 p-4 bg-gray-100 rounded-lg">
          <h3 className="font-semibold mb-2">Selected Address</h3>
          <p><strong>Street:</strong> {selected.street}</p>
          <p><strong>City:</strong> {selected.city}</p>
          {selected.lat && selected.lng && (
            <p><strong>Coordinates:</strong> {selected.lat}, {selected.lng}</p>
          )}
          <button
            className="mt-2 px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
            onClick={() => setSelected(null)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
}

export default AddressList;
